<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>

        <div v-if="!visibleAuditInfo">
            <a href="" name="up"></a>

            <b-row class="m-0">
                <!-- List Users -->
                <b-col md="5" lg="3" sm="12" class="p-0">
                    <b-list-group>
                        <b-list-group-item v-for="(item, index) in futureUsers" 
                                        :key="index"
                                        button
                                        class="wrap-name-property"
                                        @click="getFutureUserAudits(item)">
                            <div class="mb-5px"> <span> ФИО: </span> {{ item.FullName }} </div>
                            <div class="mb-5px"> <span> DAX: </span> {{ item.Dax }} </div>
                            <div class="mb-5px"> <span> Email: </span> {{ item.Email }} </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <!-- List future user audits -->
                <b-col>

                    <div v-if="!futureAudits.length">
                        <div class="mb-15 center">
                            <font-awesome-icon icon="clipboard-list" size="4x" color="#9d9d9d"/>
                        </div>
                        <div class="center stub-ladel">
                            Будущих аудитов нет
                        </div>
                    </div>

                    <div v-else-if="!futureUserAudits.length && futureAudits.length && userSelected">
                        <div class="mb-15 center">
                            <font-awesome-icon icon="clipboard-list" size="4x" color="#9d9d9d"/>
                        </div>
                        <div class="center stub-ladel">
                            У выбранного пользователя нет будущих аудитов
                        </div>
                    </div>

                    <b-list-group v-else-if="futureUserAudits.length">
                        <b-list-group-item button 
                                            v-for="(item, index) in futureUserAudits[0].Audits"
                                            :key="index"
                                            @click="getFutureAudit(item)"
                                            class="wrap-name-property">

                            <div class="mb-5px"> <span> Имя: </span> {{ item.Name }} </div>
                            <div class="mb-5px"> <span> Создан: </span> {{ getDateToDisplay(item.CreatedDate) }} </div>
                            <div class="mb-5px"> <span> Активность: </span> {{ item.TemplateName }} </div>

                            <div class="mb-5px"> 
                                <span> Статус: </span> 
                                <span :style="`color: ${statusColor(item.Status)}; margin-left: 5px`">
                                    {{ statusText(item.Status) }}
                                </span> 
                            </div>

                        </b-list-group-item>
                    </b-list-group>

                </b-col>
            </b-row>
            
            <a href="#up">
                <div class="scroll-up">                
                    <font-awesome-icon icon="caret-up" size="2x" />                
                </div>
            </a>
        </div>

        <!-- Display info about future audit -->
        <div v-else>
                <b-button block 
                          id="admin-btn-save" 
                          class="admin-button" 
                          @click="visibleAuditInfo = false">
                    Скрыть
                </b-button>

            <b-row class="mt-20">
                <b-col class="p-0 audit-block-row">
                    <div id="audit-name"> 
                      <h3 class="m-0"> 
                        {{ getDateToDisplay(futureAudit.Name, futureAudit.LocalTimeZone, true) }} 
                        {{ futureAudit.LocalTimeZone != '00:00:00' ? `(GMT+${Number(futureAudit.LocalTimeZone.split(':')[0])})` : '' }}
                      </h3> 
                      <span :style="`color: ${statusColor(futureAudit.Status)}; margin-left: 10px`"> {{ statusText(futureAudit.Status) }} </span>  
                    </div>
                    <b-row class="mb-5px"> <span> Тип: </span> {{ getAuditType(futureAudit.Type) }}  </b-row>
                    <b-row class="mb-5px"> <span> Создан:</span>
                    {{ getDateToDisplay(futureAudit.CreatedDate, futureAudit.LocalTimeZone) }}
                    {{ futureAudit.LocalTimeZone != '00:00:00' ? `(GMT+${Number(futureAudit.LocalTimeZone.split(':')[0])})` : '' }}   
                    </b-row>
                    <b-row class="mb-5px"> <span> Отправлен:</span>{{ sendText() }}  </b-row>
                    <b-row class="mb-5px"> <span> Активность:</span>{{ futureAudit.TemplateName }} </b-row>
                    <b-row class="mb-5px"> <span> Комментарий:</span>{{ futureAudit.Comment ? futureAudit.Comment : 'Отсутствует' }} </b-row>
                    <b-row class="mb-5px"> <span> Локация создания:</span>{{ locationText(futureAudit.CreationLocation) }} </b-row>
                    <b-row class="mb-5px"> <span> Локация завершения:</span>{{ locationText(futureAudit.CompletionLocation) }} </b-row>
                </b-col>
            </b-row>

            <b-row class="m-0">
                <b-col class="p-0" sm="12" md="12" lg="6">
                    <b-list-group>
                        <b-list-group-item v-for="(item, index) in futureAudit.FormList" :key="index" class="wrap-name-property">
                            <div class="mb-5px"> <span>ТТ: </span>{{ item.Name }} </div>
                            <div class="mb-5px"> <span>Создан: </span>
                              {{ getDateToDisplay(item.CreationDate, futureAudit.LocalTimeZone) }}
                              {{ futureAudit.LocalTimeZone != '00:00:00' ? `(GMT+${Number(futureAudit.LocalTimeZone.split(':')[0])})` : '' }}                      
                            </div>
                            <div class="mb-5px"> <span>Завершен: </span>
                              {{ getDateToDisplay(item.CompletionDate, futureAudit.LocalTimeZone) }}
                              {{ futureAudit.LocalTimeZone != '00:00:00' ? `(GMT+${Number(futureAudit.LocalTimeZone.split(':')[0])})` : '' }} 
                            </div>
                            <div class="mb-5px"> <span>Локация создания: </span>{{ locationText(item.CreationLocation) }} </div>
                            <div class="mb-5px"> <span>Локация завершения: </span>{{ locationText(item.CompletionLocation) }} </div>
                            <div class="mb-5px">
                                <span>Статус: </span>
                                <span :style="'color: ' + statusColor(item.Status)">
                                    {{ statusText(item.Status) }}
                                </span> 
                            </div>    

                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

export default {

    data: function() {

        let load = new Loading();

        this.getUsers(load);
        this.getFutureAudits(load);

        return {
            load: load,

            visibleAuditInfo: false,

            users: [],
            futureAudits: [],            
            
            userSelected: null,
            futureUserAudits: [],
            futureAudit: null
        }
    },
    computed: {
        futureUsers: function() {
            return this.users.filter(u => this.futureAudits.some(a => a.Creator == u.Id));
        }
    },
    methods: {
        getUsers: function(load) {
            load.Calculate(true);

            apiService.Admin.Audits.GetUsers()
                .then(response => {
                    this.users = response.data;
                    load.Calculate(false);
                })
                .catch(exception => {
                    load.Calculate(false);
                });
        },

        getFutureAudits: function(load) {
            load.Calculate(true);

            apiService.Admin.Audits.GetFutureAudits()
                .then(response => {
                    this.futureAudits = response.data;
                    load.Calculate(false);
                })
                .catch(exception => {
                    load.Calculate(false);
                });
        },

        getFutureAudit: function(audit) {
            this.load.Calculate(true);

            apiService.Admin.Audits.GetUserAuditData(audit.Creator, audit.Id)
                .then(response => {
                    this.futureAudit = response.data;
                    this.visibleAuditInfo = true;
                    this.load.Calculate(false);
                })
                .catch(exception => {
                    this.load.Calculate(false);
                });
        },

        getFutureUserAudits: function(user) {
            this.userSelected = user;
            this.futureUserAudits = this.futureAudits.filter(e => e.Creator === user.Id);       
        },

        statusColor: function(status) {
            switch (status) {
                case 0:
                    return "black";
                case 1:
                    return "#f39f18";
                case 2:
                    return "#00af00";
                case 3:
                    return "#1faee9";
                case 4:
                    return "red";
                default:
                    return "black";
            }
        },
        statusText: function(status) {
            switch (status) {
                case 0:
                    return "INVALID";
                case 1:
                    return "В работе";
                case 2:
                    return "Завершен";
                case 3:
                    return "Отправлен";
                case 4:
                    return "Удален";
                default:
                    return "ERROR";
            }
        },

        getAuditType: function(type) {
            switch (type) {
                case 0:
                    return "INVALID";
                case 1:
                    return "Полевая активность";
                case 2:
                    return "Горячая линия";
                case 3:
                    return "Я - инспектор";
            }
        },

        sendText: function() {
            switch (this.futureAudit.Status) {
                case 1:
                case 4:
                    return "Не отправлен";
                case 2:
                    return "XXXXXXXXX";
                case 3:
                    return this.futureAudit.LocalTimeZone != '00:00:00' ? `${this.getDateToDisplay(this.futureAudit.SendDate, this.futureAudit.LocalTimeZone, false, true)} 
                          (GMT+${Number(this.futureAudit.LocalTimeZone.split(':')[0])})
                        ` : this.getDateToDisplay(this.futureAudit.SendDate);
                default:
                    return "ERROR";
            }
        },

        locationText: function(location) {
            if(!location)
                return 'Неизвестно';

            return location.Latitude + " | " + location.Longitude;
        },

        getDateToDisplay: function (value, localTimeZone, parseDateToRu, offBrowserLocalTimeZone) {
          let dateToDisplay = new Date(value);
          if (parseDateToRu && this.futureAudit.AppVersion != 'Web') {
            dateToDisplay = dateToDisplay.toLocaleString()
          }
          //Проверка корректного преобразования значения в дату
          if (Number.isNaN(Number(dateToDisplay))) {
            return value
          }
          this.localTimeZone = localTimeZone != undefined ? localTimeZone : this.localTimeZone;
          //Получение даты с учетом след. факторов: откуда аудит, проверка переменную "localTimeZone",
          //и обработка с учетом GMT+3 на сервере
          localTimeZone != undefined && this.localTimeZone != '00:00:00' && (this.futureAudit.AppVersion == 'Web' ? true : offBrowserLocalTimeZone) ? 
            3 > Number(localTimeZone.split(':')[0])
              ? dateToDisplay.setHours(dateToDisplay.getHours() - (3 - Number(localTimeZone.split(':')[0])))
              : dateToDisplay.setHours(dateToDisplay.getHours() + (Number(localTimeZone.split(':')[0]) - 3))
            : dateToDisplay;
          dateToDisplay = `${this.getDateString(dateToDisplay)} ${this.getTimeString(dateToDisplay)}`;
          return dateToDisplay;
        },

        getDateString(value) {
            const date = `${value.getDate()}`.length == 1
                            ? `0${value.getDate()}`
                            : value.getDate();

            const month = `${value.getMonth() + 1}`.length == 1
                            ? `0${value.getMonth() + 1}`
                            : value.getMonth() + 1;

            const year = value.getFullYear();

            return `${date}.${month}.${year}`;
        },

        getTimeString(value) {
            const hours = `${value.getHours()}`.length == 1 
                            ? `0${value.getHours()}`
                            : value.getHours();

            const minutes = `${value.getMinutes()}`.length == 1 
                            ? `0${value.getMinutes()}`
                            : value.getMinutes();

            const seconds = `${value.getSeconds()}`.length == 1 
                            ? `0${value.getSeconds()}`
                            : value.getSeconds();

            return `${hours}:${minutes}:${seconds}`;
        },
    },
    components: {
        Spinner
    }
}
</script>